<template>
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="28" cy="28" r="28" fill="white" fill-opacity="0.12" />
    <circle cx="28" cy="28" r="27.5" stroke="white" stroke-opacity="0.3" />
    <g clip-path="url(#clip0_9580_34099)">
      <path
        d="M20.4167 19.3334H24.75L26.9167 24.75L24.2083 26.375C25.3685 28.7275 27.2725 30.6315 29.625 31.7917L31.25 29.0834L36.6667 31.25V35.5834C36.6667 36.158 36.4384 36.7091 36.0321 37.1154C35.6257 37.5218 35.0746 37.75 34.5 37.75C30.2742 37.4932 26.2885 35.6987 23.2949 32.7051C20.3013 29.7115 18.5068 25.7258 18.25 21.5C18.25 20.9254 18.4783 20.3743 18.8846 19.968C19.2909 19.5616 19.842 19.3334 20.4167 19.3334Z"
        stroke="#F54308"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9580_34099">
        <rect
          width="26"
          height="26"
          fill="white"
          transform="translate(15 15)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
